// ── Enhanced Visual Effects — Barrel re-export ──
// CS-style muzzle flashes, bullet holes, smoke, shell casings, explosions
// All effects self-clean via a central animation loop (no per-effect RAF chains)

export { EFFECT_LAYER, addEffect, createSpriteTexture, markEffect, disposeMesh, rand } from './effect-loop';
export type { ActiveEffect } from './effect-loop';
export { spawnEnhancedMuzzleFlash } from './effect-muzzle';
export { createBulletHoleTexture, spawnBulletHole, spawnSmoke, detectSurfaceType } from './effect-impact';
export type { SurfaceType } from './effect-impact';
// F-RN-005: spawnShellCasing/spawnExplosion deleted — no production caller
// (superseded by ShellCasingSystem + spawnHEExplosion).

// ---------------------------------------------------------------------------
// Pre-cache commonly used textures at module load time
// ---------------------------------------------------------------------------

import { createSpriteTexture } from './effect-loop';
import { createBulletHoleTexture } from './effect-impact';

let _texturesWarmed = false;

export function warmEffectTextures(): void {
  if (_texturesWarmed) return;
  _texturesWarmed = true;
  // Muzzle flash
  createSpriteTexture(64, 'rgba(255,255,220,1)', 'rgba(255,160,30,0.8)', 'circle');
  // Smoke puff
  createSpriteTexture(64, 'rgba(160,155,145,0.6)', 'rgba(120,115,105,0.2)', 'smoke');
  // Dust impact
  createSpriteTexture(32, 'rgba(180,170,150,0.8)', 'rgba(140,130,110,0.3)', 'circle');
  // Smoke grenade-style
  createSpriteTexture(64, 'rgba(180,175,165,0.7)', 'rgba(130,125,115,0.3)', 'smoke');
  // Explosion fire
  createSpriteTexture(64, 'rgba(255,200,50,1)', 'rgba(255,80,10,0.8)', 'circle');
  // Bullet hole
  createBulletHoleTexture();
}
